import { RULE_ACTIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const ruleActionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RULE_ACTIONS_ACTION_TYPE.GET_RULE_ACTIONS:
      return payload || initialState;

    default:
      return state;
  }
};

export default ruleActionsReducer;
